module.exports = __webpack_public_path__ + "static/img/text.9abec05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/text.png
// module id = Prft
// module chunks = 1